import { useEffect, useRef, useState } from "react";

export const CountUp = ({ value, decimals = 0, duration = 700 }) => {
  const [n, setN] = useState(0);
  const done = useRef(false);

  useEffect(() => {
    if (!Number.isFinite(value)) return;
    if (done.current || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setN(value);
      done.current = true;
      return;
    }
    done.current = true;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      setN(value * (1 - Math.pow(1 - p, 3)));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, duration]);

  return <>{Number.isFinite(value) ? n.toFixed(decimals) : value}</>;
};
